import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import DynamicQuantitySelect from 'dibs-dynamic-quantity-select';
import { injectIntl, intlShape } from 'react-intl';

class CartQuantitySelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedQuantity: '1',
        };
    }

    isValidCtaQuantity() {
        const { item } = this.props;
        const { hasUnlimitedQuantity, quantity } = item;
        const { selectedQuantity } = this.state;
        return hasUnlimitedQuantity || Number(selectedQuantity) <= quantity;
    }

    render() {
        const { children, intl, selectClassName, item } = this.props;
        const { selectedQuantity } = this.state;
        const quantitySelectOptions = get(item, 'quantitySelectOptions') || [];
        const availableQuantity = get(item, 'quantity');
        const setSize = get(item, 'setSize');
        const ctaQuantity = this.isValidCtaQuantity(selectedQuantity) ? selectedQuantity : '1';

        if (quantitySelectOptions && quantitySelectOptions.length) {
            return (
                <div>
                    <div data-tn="quantity-select" className={selectClassName}>
                        <DynamicQuantitySelect
                            availableQuantity={availableQuantity}
                            hasAnimatedPlaceholder
                            intl={intl}
                            options={quantitySelectOptions}
                            value={selectedQuantity}
                            onChange={e => this.setState({ selectedQuantity: e.target.value })}
                            soldAsSet={setSize && setSize > 1}
                        />
                    </div>
                    {children(ctaQuantity)}
                </div>
            );
        }

        return children(null);
    }
}

CartQuantitySelect.propTypes = {
    children: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    selectClassName: PropTypes.string,
};

export default createFragmentContainer(injectIntl(CartQuantitySelect), {
    item: graphql`
        fragment CartQuantitySelect_item on Item {
            quantity
            hasUnlimitedQuantity
            setSize
            quantitySelectOptions {
                label
                value
            }
        }
    `,
});
